import {
  Module,
  VuexModule,
  getModule,
  Action,
  Mutation
} from 'vuex-module-decorators';
import store from '@/store';
import { PrivacyConfirmationRequest, CountriesOptionResponse } from '../models';
import {
  submitPrivacyConfirmation,
  fetchCountriesOption,
  validateSalesToken,
  initWhatsAppPage,
  fetchMoreCountriesOption,
  fetchLanguagesOption
} from '../api';

@Module({
  dynamic: true,
  namespaced: true,
  name: 'privacyConfirmModule',
  store
})
class PrivacyConfirmModule extends VuexModule {
  public countriesOptionResult: CountriesOptionResponse | null = null;
  public moreCountriesOptionResult: CountriesOptionResponse | null = null;
  public languageOptionResult: CountriesOptionResponse | null = null;

  @Mutation
  public setCountriesOptionResult(
    countriesOptionResult: CountriesOptionResponse
  ) {
    this.countriesOptionResult = countriesOptionResult;
  }

  @Mutation
  public setMoreCountriesOptionResult(
    moreCountriesOptionResult: CountriesOptionResponse
  ) {
    this.moreCountriesOptionResult = moreCountriesOptionResult;
  }

  @Mutation
  public setLanguagesOptionResult(
    languageOptionResult: CountriesOptionResponse
  ) {
    this.languageOptionResult = languageOptionResult;
  }

  @Action({ rawError: true })
  public async processPrivacyConfirmation(
    requestObj: PrivacyConfirmationRequest
  ) {
    try {
      const redirectResult = await submitPrivacyConfirmation(requestObj);
      return redirectResult;
    } catch (error) {
      throw new Error(error as string);
    }
  }

  @Action({ commit: 'setMoreCountriesOptionResult', rawError: true })
  public async getMoreCountriesOption() {
    try {
      const countriesOptionResult = await fetchMoreCountriesOption();
      return countriesOptionResult;
    } catch (error) {
      throw new Error(error as string);
    }
  }

  @Action({ commit: 'setLanguagesOptionResult', rawError: true })
  public async getLanguagesOption() {
    try {
      const countriesOptionResult = await fetchLanguagesOption();
      return countriesOptionResult;
    } catch (error) {
      throw new Error(error as string);
    }
  }

  @Action({ commit: 'setCountriesOptionResult', rawError: true })
  public async getCountriesOption() {
    try {
      const countriesOptionResult = await fetchCountriesOption();
      return countriesOptionResult;
    } catch (error) {
      throw new Error(error as string);
    }
  }

  @Action({ rawError: true })
  public async validateTestUserToken(salesToken: string) {
    try {
      const valid = await validateSalesToken(salesToken);
      return valid;
    } catch (error) {
      throw new Error(error as string);
    }
  }

  @Action({ rawError: true })
  public async doInitWhatsAppPage(languageCode: string) {
    try {
      const response = await initWhatsAppPage(languageCode);
      return response;
    } catch (error) {
      throw new Error(error as string);
    }
  }
}

export default getModule(PrivacyConfirmModule);
